import { ModalScreen } from "../modal-screen";
import { customElement, property, state } from "lit/decorators.js";
import { html } from "lit";
import gameApp from "@/index";
import { CustomToast } from "../toast";

@customElement("room-settings")
export class RoomSettings extends ModalScreen {
  @property({ type: Array }) tabs: any = [];
  @property({ type: String }) activeTab: string = "";
  @state() roomName: string = "";
  @state() privacySetting: "public" | "private" | "restricted" = "public";
  @state() password: string = ""; // Added password state
  @state() confirmPassword: string = ""; // Added confirm password state
  roomId: string;
  @property({ type: String }) errors: any = {};

  constructor() {
    super();
  }

  async openModal(roomId: string) {
    this.isOpen = true;
    this.roomId = roomId;

    try {
      const response = await fetch(
        `${process.env.BASE_API_URL}/room-info?id=${roomId}`,
        {
          method: "GET",
          credentials: "include",
        }
      );

      if (response.ok) {
        const data = await response.json();
        this.roomName = data.room?.name || "";
        this.privacySetting = data.room?.accessLevel || "public";
      } else {
        console.error("Failed to fetch room details");
      }
    } catch (error) {
      console.error("Error fetching room data:", error);
    }

    this.tabs = [
      { slug: "general", label: "General" },
      { slug: "privacy", label: "Privacy" },
    ];

    this.selectTab("general");
  }

  selectTab(tabId: string) {
    this.activeTab = tabId;
  }

  handleInputChange(e: Event) {
    const target = e.target as HTMLInputElement;
    this.roomName = target.value;
  }

  handlePrivacyChange(e: Event) {
    const target = e.target as HTMLInputElement;
    this.privacySetting = target.value as "public" | "private" | "restricted";

    if (this.privacySetting !== "restricted") {
      this.password = "";
      this.confirmPassword = "";
    }
  }

  handlePasswordChange(e: Event) {
    const target = e.target as HTMLInputElement;
    this.password = target.value;
  }

  handleConfirmPasswordChange(e: Event) {
    const target = e.target as HTMLInputElement;
    this.confirmPassword = target.value;
  }

  async handleFormSubmit(e: Event) {
    e.preventDefault();

    try {
      const response = await fetch(
        `${process.env.BASE_API_URL}/room-settings`,
        {
          method: "POST",
          body: JSON.stringify({
            action: this.activeTab,
            roomName: this.roomName,
            password: this.password,
            access_level: this.privacySetting,
            confirmPassword: this.confirmPassword,
            roomId: this.roomId,
          }),
          credentials: "include",
        }
      );

      if (response.ok) {
        const data = await response.json();
        if (data.message) {
          const toast = document.querySelector("custom-toast") as CustomToast;
          toast?.openToast(data.message, "top-right", 3000, "success");

          gameApp.wsClient.sendMessage(
            JSON.stringify({
              action: "room_actions",
              arguments: {
                roomId: this.roomId,
              },
            })
          );
        } else {
          this.errors = data;
        }
      } else {
        console.error("Failed to fetch room details");
      }
    } catch (error) {
      console.error("Error fetching room data:", error);
    }
    // if (
    //   this.privacySetting === "restricted" &&
    //   this.password !== this.confirmPassword
    // ) {
    //   alert("Passwords do not match.");
    //   return;
    // }

    // gameApp.wsClient.sendMessage(
    //   JSON.stringify({
    //     action: "room_actions",
    //     arguments: {
    //       action: "room-settings",
    //       roomId: this.roomId,
    //       title: this.roomName,
    //       privacy: this.privacySetting,
    //       password: this.privacySetting === "restricted" ? this.password : null,
    //     },
    //   })
    // );
  }

  render() {
    if (!this.isOpen) {
      return html``;
    }

    return html`
      <div class="modal">
        <div class="modal__top">
          ${this.tabs.map(
            (tab) => html`
              <span
                class="modal__tab ${this.activeTab === tab.slug
                  ? "is-active"
                  : ""}"
                @click="${() => this.selectTab(tab.slug)}"
              >
                ${tab.label}
              </span>
            `
          )}
          <button class="modal__close" @click="${this.closeModal}">
            <span>Close</span>
          </button>
        </div>

        <div class="modal__body">
          ${this.activeTab === "general"
            ? html`
                <form class="memberform" @submit="${this.handleFormSubmit}">
                  <div class="memberform-input-group">
                    <label for="roomName">Room Name:</label>
                    <input
                      class="input"
                      id="roomName"
                      type="text"
                      .value="${this.roomName}"
                      @input="${this.handleInputChange}"
                    />

                    ${this.errors.field === "roomName"
                      ? html`<div class="error-message">
                          ${this.errors.error}
                        </div>`
                      : ""}
                  </div>
                  <button type="submit" class="btn">Save</button>
                </form>
              `
            : html`
                <form class="memberform" @submit="${this.handleFormSubmit}">
                  <fieldset>
                    <legend>Privacy Settings</legend>

                    <label style="position: relative; z-index: 99;">
                      <input
                        type="radio"
                        name="privacy"
                        style="position: relative;"
                        value="public"
                        .checked="${this.privacySetting === "public"}"
                        @change="${this.handlePrivacyChange}"
                      />
                      Room open
                    </label>
                    <label style="position: relative; z-index: 99;">
                      <input
                        type="radio"
                        name="privacy"
                        style="position: relative;"
                        value="private"
                        .checked="${this.privacySetting === "private"}"
                        @change="${this.handlePrivacyChange}"
                      />
                      Room locked
                    </label>
                    <label style="position: relative; z-index: 99;">
                      <input
                        type="radio"
                        name="privacy"
                        style="position: relative;"
                        value="restricted"
                        .checked="${this.privacySetting === "restricted"}"
                        @change="${this.handlePrivacyChange}"
                      />
                      Room with password
                    </label>

                    ${this.privacySetting === "restricted"
                      ? html`
                          <div
                            class="memberform-input-group"
                            style="margin-top: 20px;"
                          >
                            <label for="password">Password:</label>
                            <input
                              class="input"
                              id="password"
                              type="password"
                              .value="${this.password}"
                              @input="${this.handlePasswordChange}"
                            />

                            ${this.errors.field === "password"
                              ? html`<div class="error-message">
                                  ${this.errors.error}
                                </div>`
                              : ""}
                          </div>
                          <div class="memberform-input-group">
                            <label for="confirmPassword"
                              >Confirm Password:</label
                            >
                            <input
                              class="input"
                              id="confirmPassword"
                              type="password"
                              .value="${this.confirmPassword}"
                              @input="${this.handleConfirmPasswordChange}"
                            />
                          </div>
                        `
                      : ""}
                  </fieldset>
                  <button type="submit" class="btn">Save</button>
                </form>
              `}
        </div>
      </div>
    `;
  }
}
